module.exports = __webpack_public_path__ + "static/media/Twitter.c479d92e.svg";